import React from "react";
import ReactPlayer from "react-player";
import "./styles.scss";

const OneVideo = (props) => {
  const { video, controls, loop } = props;
  const url = video?.videoUrl;
  const ShouldRenderVideo = !!url;

  return (
    ShouldRenderVideo && (
      <ReactPlayer
        className="react-player"
        width="100%"
        height="auto"
        controls={controls}
        muted={true}
        loop={loop}
        fallback={<img src={video?.image} alt="Default" />}
        url={url?.replaceAll("\\/", "/")?.replaceAll("\\", "")}
        playing={true}
      />
    )
  );
};

export default OneVideo;
